export default {
  SET_INIT(state, payload) {
    state.init = payload;
  },

  SET_LANG(state, payload) {
    state.lang = payload;
  },

  IS_MOBILE(state, payload) {
    state.mobile = payload;
  },

  IS_TOUCH(state, payload) {
    state.touch = payload;
  },

  TOGGLE_MENU(state) {
    state.menu = !state.menu;
  },

  TOGGLE_MENUTRANS(state) {
    state.menuTrans = !state.menuTrans;
  },

  SET_DATA(state, payload) {
    state.firebase = payload;
  },

  SET_SETTINGS(state, payload) {
    state.settings = payload;
  },

  SET_TRANSNAME(state, payload) {
    state.transName = payload;
  },

  IS_TRANS(state, payload) {
    state.isTrans = payload;
  },

  SET_ROUTENAME(state, payload) {
    state.routeName = payload;
  },

  SET_NEXT(state, payload) {
    state.next = payload;
  },

  SET_PREV(state, payload) {
    state.prev = payload;
  },

  SET_GOHOME(state, payload) {
    state.goHome = payload;
  },

  FORM_STATUS(state, payload) {
    state.formStatus = payload;
  },

  SET_PEOPLE_ID(state, payload) {
    state.peopleId = payload;
  },
};
